import styled from 'styled-components';
import { StyledCountryWithFlagProps } from './CountryWithFlag.types';

export const StyledCountryWithFlag = styled.div<StyledCountryWithFlagProps>`
  display: inline-flex;
  align-items: center;

  .country-with-flag__name {
    margin-left: 6px;
  }
  ${(props) => props.customStyle}
`;
